import { Stack, Theme, Typography } from '@mui/material'
import { DateTime } from 'luxon';

interface EventTitleProps {
  title: string
  date: string
  disabled?: boolean
}

const HistoryEventTitle: React.FC<EventTitleProps> = ({ title, date, disabled }) => {
  const parsedDate = DateTime.fromISO(date).toFormat('MM/dd/yyyy, t')

  return (
    <Stack direction="row" justifyContent="space-between" sx={disabled ? styles.disabled : null}>
      <Typography>
        {title}
      </Typography>
      <Typography variant="caption" color="text.secondary" sx={styles.timeLabel}>
        {parsedDate}
      </Typography>
    </Stack>
  );
};

const styles = {
  disabled: {
    color: (theme: Theme) => theme.palette.grey[400],
  },
  timeLabel: {
    fontSize: '14px',
  }
} as const;

export default HistoryEventTitle;
